(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.re-exit-property.view
  (:require
   [frontend.ui.component.lp-portal.section.view :as section]
   [frontend.ui.component.lp-portal.card.view :as card]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.view :as locations]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]))

(defn view
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name case-overview-text overview map-data]} holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [section/section
      (str holding-name " - exited investment")
      nil
      [card/card {:title ""}
       [free-text-card/free-text-section "Investment overview" case-overview-text props]
       [:<>
        [tabular-card/dynamic-stacked-table overview props]
        [locations/portfolio-locations-card map-data props]]]]]))
